/**
 * @desc 根据季度查询季度计划基础信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.QuarterRequest,
): Promise<defs.StandardReturn<defs.PlanQuarterInfoResponse>> {
  return defHttp.post({
    url: '/web/plan/quarter/queryPlanInfoByQuarter',
    data,
  });
}

export function mock(
  data: defs.QuarterRequest,
): Promise<defs.StandardReturn<defs.PlanQuarterInfoResponse>> {
  return defHttp.post({
    url: '/mock/web/plan/quarter/queryPlanInfoByQuarter',
    data,
  });
}
